import { render, staticRenderFns } from "./RoleCopy.vue?vue&type=template&id=a917227e&"
import script from "./RoleCopy.vue?vue&type=script&lang=js&"
export * from "./RoleCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports